// =============================================================================
// ACT MATH TEST BANK
// Form 25MC5 (ACT Practice Test 2, 2025-2026)
// =============================================================================
//
// SOURCE: ACT Practice Multiple Choice Test 2 (Form 25MC5)
// TYPE: Practice Test (Enhanced ACT Format)
// USE: TESTING MODE
//
// FORMAT: Enhanced ACT
//   - 45 total questions, 41 scored
//   - 4 field test questions (Q8, Q18, Q28, Q38)
//   - 50 minutes
//
// =============================================================================

export const FORM_METADATA = {
  formId: '25MC5',
  source: 'ACT Practice Multiple Choice Test 2 (2025-2026)',
  testType: 'Practice Test',
  format: 'Enhanced',
  totalQuestions: 45,
  scoredQuestions: 41,
  fieldTestPositions: [8, 18, 28, 38],
  timeMinutes: 50
};

// Official Scale Score Conversion (Form 25MC5)
export const SCALE_SCORE_TABLE_25MC5 = [
  { raw: 41, scale: 36 }, { raw: 40, scale: 36 },
  { raw: 39, scale: 35 },
  { raw: 38, scale: 34 },
  { raw: 37, scale: 33 },
  { raw: 36, scale: 31 },
  { raw: 35, scale: 30 },
  { raw: 34, scale: 29 },
  { raw: 33, scale: 28 },
  { raw: 32, scale: 27 }, { raw: 31, scale: 27 },
  { raw: 30, scale: 26 },
  { raw: 29, scale: 25 }, { raw: 28, scale: 25 },
  { raw: 27, scale: 24 },
  { raw: 26, scale: 23 },
  { raw: 25, scale: 22 },
  { raw: 24, scale: 21 },
  { raw: 23, scale: 20 },
  { raw: 22, scale: 19 },
  { raw: 21, scale: 18 }, { raw: 20, scale: 18 },
  { raw: 19, scale: 17 }, { raw: 18, scale: 17 }, { raw: 17, scale: 17 },
  { raw: 16, scale: 16 }, { raw: 15, scale: 16 }, { raw: 14, scale: 16 },
  { raw: 13, scale: 15 }, { raw: 12, scale: 15 },
  { raw: 11, scale: 14 }, { raw: 10, scale: 14 }, { raw: 9, scale: 14 }, { raw: 8, scale: 14 },
  { raw: 7, scale: 13 },
  { raw: 6, scale: 12 },
  { raw: 5, scale: 11 },
  { raw: 4, scale: 10 },
  { raw: 3, scale: 9 },
  { raw: 2, scale: 7 },
  { raw: 1, scale: 4 },
  { raw: 0, scale: 1 }
];

export const questions_25MC5 = [
  // Question 1
  {
    id: '25MC5-Q01',
    formId: '25MC5',
    questionNumber: 1,
    category: 'S',
    isScored: true,
    difficulty: 1,
    question: 'At a college track meet, there are 3 jumping events: high jump, long jump, and triple jump. The Venn diagram below shows the distribution of the number of athletes competing in each jumping event. How many athletes are competing in both high jump and triple jump but not long jump?',
    questionNote: 'Venn diagram shows: high jump only: 5, long jump only: 7, triple jump only: 2, high∩long: 9, high∩triple: 3, long∩triple: 6, all three: 1',
    choices: ['3', '4', '10', '19'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'Looking at the Venn diagram, the region representing athletes in both high jump and triple jump but NOT long jump is the value 3.',
    topicTags: ['venn-diagrams', 'sets']
  },
  // Question 2
  {
    id: '25MC5-Q02',
    formId: '25MC5',
    questionNumber: 2,
    category: 'F',
    isScored: true,
    difficulty: 1,
    question: 'A function, f, is defined by the equation f(x) = x² + 5. What is f(3) + 1?',
    choices: ['9', '11', '12', '15'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'f(3) = 3² + 5 = 9 + 5 = 14. Then f(3) + 1 = 14 + 1 = 15.',
    topicTags: ['function-evaluation']
  },
  // Question 3
  {
    id: '25MC5-Q03',
    formId: '25MC5',
    questionNumber: 3,
    category: 'IES',
    isScored: true,
    difficulty: 1,
    question: 'Given b = 40 and c = −16, b + c is equal to the product of −4 and what number?',
    choices: ['−14', '−6', '6', '14'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'b + c = 40 + (−16) = 24. If −4 × n = 24, then n = 24 ÷ (−4) = −6.',
    topicTags: ['integer-operations', 'word-problems']
  },
  // Question 4
  {
    id: '25MC5-Q04',
    formId: '25MC5',
    questionNumber: 4,
    category: 'N',
    isScored: true,
    difficulty: 1,
    question: 'It takes Collin 24 minutes to walk to school in the morning. What fraction of his 24‑hour day is spent walking to school in the morning?',
    choices: ['1/1,440', '1/60', '1/24', '1/12'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: '24 hours = 24 × 60 = 1,440 minutes. Fraction = 24/1,440 = 1/60.',
    topicTags: ['fractions', 'unit-conversion']
  },
  // Question 5
  {
    id: '25MC5-Q05',
    formId: '25MC5',
    questionNumber: 5,
    category: 'IES',
    isScored: true,
    difficulty: 1,
    question: 'A certain triangle has interior angle measures of (6x)°, (2x)°, and x°. What is the value of x?',
    choices: ['9', '12', '20', '57'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'Sum of angles in a triangle = 180°. So 6x + 2x + x = 180, 9x = 180, x = 20.',
    topicTags: ['triangles', 'linear-equations']
  },
  // Question 6
  {
    id: '25MC5-Q06',
    formId: '25MC5',
    questionNumber: 6,
    category: 'N',
    isScored: true,
    difficulty: 2,
    question: 'Which of the following matrices is equal to 6[−5  3; 0  −4]?',
    choices: ['[−30  −6]', '[1  9; 6  2]', '[−5/6  1/2; 0  −2/3]', '[−30  18; 0  −24]'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Multiply each element by 6: 6(−5) = −30, 6(3) = 18, 6(0) = 0, 6(−4) = −24. Result: [−30  18; 0  −24].',
    topicTags: ['matrices', 'scalar-multiplication']
  },
  // Question 7
  {
    id: '25MC5-Q07',
    formId: '25MC5',
    questionNumber: 7,
    category: 'G',
    isScored: true,
    difficulty: 2,
    question: 'For circle O shown, A, B, C, and D are on circle O; A and B are as far apart as possible; C is halfway between A and B along circle O; and D is halfway between C and B along circle O. What percent of the area enclosed by circle O is enclosed by OC̄, OD̄, and minor arc CD?',
    choices: ['12.5%', '25%', '50%', '100%'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'A and B are endpoints of a diameter. C is at 90° from A (quarter circle). D is at 45° from C (halfway between C and B). The sector COD has central angle of 45°. Area fraction = 45/360 = 1/8 = 12.5%.',
    topicTags: ['circles', 'arc-length', 'sector-area']
  },
  // Question 8 - FIELD TEST (Not Scored)
  {
    id: '25MC5-Q08',
    formId: '25MC5',
    questionNumber: 8,
    category: 'F',
    isScored: false,
    difficulty: 2,
    question: 'An object is launched vertically at 30 meters per second from a 55‑meter‑tall platform. The height, h(t) meters, of the object t seconds after launch is modeled by h(t) = −4.9t² + 30t + 55. What will be the height, in meters, of the object 3 seconds after launch?',
    choices: ['44.1', '100.9', '145', '189.1'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'h(3) = −4.9(3)² + 30(3) + 55 = −4.9(9) + 90 + 55 = −44.1 + 90 + 55 = 100.9 meters.',
    topicTags: ['quadratic-functions', 'function-evaluation']
  },
  // Question 9
  {
    id: '25MC5-Q09',
    formId: '25MC5',
    questionNumber: 9,
    category: 'F',
    isScored: true,
    difficulty: 2,
    question: 'Given the function f(x) = 4x² − 14x + 12, which of the following expressions is equivalent to f(x)?',
    choices: ['(−2x + 4)(2x + 3)', '(2x − 4)(2x − 3)', '(2x − 4)(2x + 3)', '(2x − 3)(2x + 4)'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'Factor: 4x² − 14x + 12 = 2(2x² − 7x + 6) = 2(2x − 3)(x − 2) = (2x − 4)(2x − 3). Check: (2x−4)(2x−3) = 4x² − 6x − 8x + 12 = 4x² − 14x + 12. ✓',
    topicTags: ['factoring', 'quadratic-equations']
  },
  // Question 10
  {
    id: '25MC5-Q10',
    formId: '25MC5',
    questionNumber: 10,
    category: 'A',
    isScored: true,
    difficulty: 1,
    question: 'Which of the following is equivalent to (6x + 3y) − (y − 2x)?',
    choices: ['4x + 2y', '5x + y', '5x + 5y', '8x + 2y'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: '(6x + 3y) − (y − 2x) = 6x + 3y − y + 2x = 8x + 2y.',
    topicTags: ['polynomial-simplification', 'combining-like-terms']
  },
  // Question 11
  {
    id: '25MC5-Q11',
    formId: '25MC5',
    questionNumber: 11,
    category: 'A',
    isScored: true,
    difficulty: 2,
    question: 'Bryce owns an apartment building. He charges $325 per month for each 1‑bedroom apartment and $410 per month for each 2‑bedroom apartment. Bryce charged a total of $4,905 in rent for 13 apartments this month. How many 1‑bedroom apartments did Bryce charge for this month?',
    choices: ['5', '6', '7', '8'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'Let x = 1-BR apts, then 13−x = 2-BR apts. 325x + 410(13−x) = 4905. 325x + 5330 − 410x = 4905. −85x = −425. x = 5.',
    topicTags: ['systems-of-equations', 'word-problems']
  },
  // Question 12
  {
    id: '25MC5-Q12',
    formId: '25MC5',
    questionNumber: 12,
    category: 'S',
    isScored: true,
    difficulty: 1,
    question: 'A restaurant surveyed its customers to determine whether or not they like hamburgers and whether or not they like turkey burgers. The table shows the results. To the nearest 1%, what percent of the customers who responded to the survey like hamburgers?',
    questionNote: 'Table: Like hamburgers: 97+98=195, Do not like hamburgers: 39+78=117, Total: 312',
    choices: ['31%', '50%', '63%', '71%'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Total who like hamburgers = 195. Total surveyed = 312. Percent = 195/312 ≈ 0.625 = 63%.',
    topicTags: ['two-way-tables', 'percentages']
  },
  // Question 13
  {
    id: '25MC5-Q13',
    formId: '25MC5',
    questionNumber: 13,
    category: 'A',
    isScored: true,
    difficulty: 2,
    question: 'For what value of n does the quadratic equation x² − 4x + n = 0 have solutions of x = 7 and x = −3?',
    choices: ['−21', '−4', '4', '10'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'If x = 7 and x = −3 are solutions, then (x−7)(x+3) = 0, which expands to x² − 4x − 21 = 0. So n = −21.',
    topicTags: ['quadratic-equations', 'roots']
  },
  // Question 14
  {
    id: '25MC5-Q14',
    formId: '25MC5',
    questionNumber: 14,
    category: 'G',
    isScored: true,
    difficulty: 2,
    question: 'The lengths of corresponding sides of 2 similar right triangles are in the ratio 4:5. The hypotenuse of the smaller triangle is 20 inches long. How many inches long is the hypotenuse of the larger triangle?',
    choices: ['9', '20', '21', '25'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Ratio of sides is 4:5. If smaller hypotenuse = 20, then 20/4 = 5 per unit. Larger = 5 × 5 = 25 inches.',
    topicTags: ['similar-triangles', 'ratios']
  },
  // Question 15
  {
    id: '25MC5-Q15',
    formId: '25MC5',
    questionNumber: 15,
    category: 'F',
    isScored: true,
    difficulty: 2,
    question: 'What is the amplitude of the graph of function f(x) = (1/2)cos(3x + π), shown in the standard (x,y) coordinate plane?',
    choices: ['1/3', '1/2', '2', '3'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'For f(x) = A cos(Bx + C), the amplitude is |A|. Here A = 1/2, so amplitude = 1/2.',
    topicTags: ['trig-functions', 'amplitude']
  },
  // Question 16
  {
    id: '25MC5-Q16',
    formId: '25MC5',
    questionNumber: 16,
    category: 'G',
    isScored: true,
    difficulty: 2,
    question: 'A circle in the standard (x,y) coordinate plane has its center at (3,−4) and passes through (0,0). Which of the following is an equation for that circle?',
    choices: ['x² + y² = 5', '(x − 3)² + (y + 4)² = 25', '(x + 3)² + (y − 4)² = 7', '(x + 3)² + (y − 4)² = 25'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Radius = distance from (3,−4) to (0,0) = √[(3−0)² + (−4−0)²] = √[9+16] = √25 = 5. Equation: (x−3)² + (y+4)² = 25.',
    topicTags: ['circles', 'coordinate-geometry', 'distance']
  },
  // Question 17
  {
    id: '25MC5-Q17',
    formId: '25MC5',
    questionNumber: 17,
    category: 'N',
    isScored: true,
    difficulty: 2,
    question: '√112 + √63 + √175 = ?',
    choices: ['7√12', '7√50', '12√7', '60√7'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: '√112 = √(16×7) = 4√7. √63 = √(9×7) = 3√7. √175 = √(25×7) = 5√7. Sum = 4√7 + 3√7 + 5√7 = 12√7.',
    topicTags: ['radicals', 'simplifying-radicals']
  },
  // Question 18 - FIELD TEST (Not Scored)
  {
    id: '25MC5-Q18',
    formId: '25MC5',
    questionNumber: 18,
    category: 'IES',
    isScored: false,
    difficulty: 2,
    question: 'The sum of 3 positive integers is 180, and the ratio of the integers is 5:3:2. What is the value of the smallest of the integers?',
    choices: ['18', '36', '54', '90'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Let integers be 5k, 3k, 2k. Sum = 10k = 180, so k = 18. Smallest = 2k = 36.',
    topicTags: ['ratios', 'word-problems']
  },
  // Question 19
  {
    id: '25MC5-Q19',
    formId: '25MC5',
    questionNumber: 19,
    category: 'S',
    isScored: true,
    difficulty: 2,
    question: 'Jeremy reaches into a box in the closet. The box contains 10 gloves that make up 5 matching pairs. He picks 1 glove at random and puts it on. Then he picks another glove at random. What is the probability that he has picked a matching pair?',
    choices: ['1/9', '1/5', '4/9', '1/2'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'After picking 1 glove, there are 9 gloves left, only 1 of which matches. P(matching) = 1/9.',
    topicTags: ['probability-basic', 'counting']
  },
  // Question 20
  {
    id: '25MC5-Q20',
    formId: '25MC5',
    questionNumber: 20,
    category: 'IES',
    isScored: true,
    difficulty: 2,
    question: 'During an event, a store gave a free T‑shirt to every 24th customer that entered the store and a free gift certificate to every 60th customer that entered the store. Given that 500 customers entered the store during the event, how many customers received both a free T‑shirt and a free gift certificate?',
    choices: ['2', '4', '12', '24'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'LCM(24, 60) = 120. Customers receiving both: 120, 240, 360, 480. That is 4 customers (500 ÷ 120 = 4.17, so 4).',
    topicTags: ['lcm', 'word-problems']
  },
  // Question 21
  {
    id: '25MC5-Q21',
    formId: '25MC5',
    questionNumber: 21,
    category: 'S',
    isScored: true,
    difficulty: 2,
    question: "Cameron's bookshelf has 3 books with a rating of 10, 5 books with a rating of 100, and 2 books with a rating of 70. There are no other books on the bookshelf. What is the expected value, to the nearest whole number, of the rating of a book randomly selected from Cameron's bookshelf?",
    choices: ['18', '60', '67', '85'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'E = (3×10 + 5×100 + 2×70) / 10 = (30 + 500 + 140) / 10 = 670/10 = 67.',
    topicTags: ['expected-value', 'weighted-average']
  },
  // Question 22
  {
    id: '25MC5-Q22',
    formId: '25MC5',
    questionNumber: 22,
    category: 'F',
    isScored: true,
    difficulty: 2,
    question: 'The 1st term of a certain sequence is −10, and the 2nd term is 1. Each subsequent term is obtained by adding the 2 immediately preceding terms. What is the 5th term of this sequence?',
    choices: ['−23', '−17', '19', '34'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Sequence: a₁=−10, a₂=1, a₃=−10+1=−9, a₄=1+(−9)=−8, a₅=−9+(−8)=−17.',
    topicTags: ['arithmetic-sequences', 'recursive-sequences']
  },
  // Question 23
  {
    id: '25MC5-Q23',
    formId: '25MC5',
    questionNumber: 23,
    category: 'IES',
    isScored: true,
    difficulty: 2,
    question: 'Which of the following values is the y‑value of the solution to the given system of equations?\n−4y − 3 = x\n2x − 22 = 6y',
    choices: ['y = −2½', 'y = −2', 'y = −¾', 'y = 5'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'From first equation: x = −4y − 3. Substitute into second: 2(−4y − 3) − 22 = 6y. −8y − 6 − 22 = 6y. −28 = 14y. y = −2.',
    topicTags: ['systems-of-equations', 'substitution']
  },
  // Question 24
  {
    id: '25MC5-Q24',
    formId: '25MC5',
    questionNumber: 24,
    category: 'F',
    isScored: true,
    difficulty: 2,
    question: 'Some values of the function g are given in the table. One of the following equations defines g. Which one?\nTable: x: −2, 0, 1, 2, 3 → g(x): 0, −8, −6, 0, 10',
    choices: ['g(x) = −2x − 8', 'g(x) = −x − 8', 'g(x) = x² + 2', 'g(x) = 2x² − 8'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Test g(x) = 2x² − 8: g(0) = 0 − 8 = −8 ✓, g(1) = 2 − 8 = −6 ✓, g(2) = 8 − 8 = 0 ✓, g(3) = 18 − 8 = 10 ✓, g(−2) = 8 − 8 = 0 ✓.',
    topicTags: ['function-evaluation', 'quadratic-functions']
  },
  // Question 25
  {
    id: '25MC5-Q25',
    formId: '25MC5',
    questionNumber: 25,
    category: 'G',
    isScored: true,
    difficulty: 1,
    question: 'The vertex angle of an isosceles triangle is 40°. What is the measure of a base angle?',
    choices: ['40°', '70°', '100°', '140°'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'In isosceles triangle, base angles are equal. 40 + 2x = 180. 2x = 140. x = 70°.',
    topicTags: ['triangles', 'isosceles-triangles']
  },
  // Question 26
  {
    id: '25MC5-Q26',
    formId: '25MC5',
    questionNumber: 26,
    category: 'G',
    isScored: true,
    difficulty: 2,
    question: 'Equilateral triangle △ABC is inscribed in circle O, as shown. What is the degree measure of minor arc BC?',
    choices: ['60°', '90°', '120°', '180°'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'In equilateral triangle, each angle = 60°. Inscribed angle = half of central angle. So central angle = 2 × 60° = 120°. Arc BC = 120°.',
    topicTags: ['circles', 'inscribed-angles', 'arc-measure']
  },
  // Question 27
  {
    id: '25MC5-Q27',
    formId: '25MC5',
    questionNumber: 27,
    category: 'IES',
    isScored: true,
    difficulty: 2,
    question: "A scale model, where 1 coordinate unit represents 1 mile, is drawn in the standard (x,y) coordinate plane. Angelo's house is at (4,−3), Ella's house is at (4,7), Troy's house is at (−2,7), and Yoko's house is at (−2,−3). Which of the following is closest to the area, in square miles, of the rectangle whose vertices are the real locations of the 4 houses?",
    choices: ['32', '36', '60', '100'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'Length = |7 − (−3)| = 10 miles. Width = |4 − (−2)| = 6 miles. Area = 10 × 6 = 60 square miles.',
    topicTags: ['coordinate-geometry', 'area']
  },
  // Question 28 - FIELD TEST (Not Scored)
  {
    id: '25MC5-Q28',
    formId: '25MC5',
    questionNumber: 28,
    category: 'F',
    isScored: false,
    difficulty: 2,
    question: 'Let the function f be defined as f(x) = −9x². In the standard (x,y) coordinate plane, the graph of y = f(x) undergoes a transformation such that the result is the graph of y = f(x) − 4. Under this transformation the graph of y = f(x) is:',
    choices: ['shifted downward 4 coordinate units.', 'shifted left 4 coordinate units.', 'stretched horizontally by a factor of 4.', 'stretched vertically by a factor of 4.'],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'Subtracting 4 from f(x) shifts the graph down by 4 units. y = f(x) − 4 is a vertical translation.',
    topicTags: ['transformations', 'function-graphs']
  },
  // Question 29
  {
    id: '25MC5-Q29',
    formId: '25MC5',
    questionNumber: 29,
    category: 'G',
    isScored: true,
    difficulty: 2,
    question: 'Which of the following expressions equals the height, in feet, of the tree shown? (Diagram shows angle of elevation 40° from a point 18 feet from tree base)',
    choices: ['18 tan 40°', '18 sin 40°', '18 cos 40°', 'tan 40° / 18'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'tan(40°) = opposite/adjacent = height/18. So height = 18 tan 40°.',
    topicTags: ['trig-ratios', 'right-triangles']
  },
  // Question 30
  {
    id: '25MC5-Q30',
    formId: '25MC5',
    questionNumber: 30,
    category: 'IES',
    isScored: true,
    difficulty: 2,
    question: 'As shown, the number line between 0 and 8 is divided into 6 segments of equal length by points A through E. Which of the following statements about √8 is true?',
    choices: ['√8 is at C.', '√8 is at D.', '√8 is between A and B.', '√8 is between B and C.'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Each segment = 8/6 = 4/3 ≈ 1.33. A ≈ 1.33, B ≈ 2.67, C = 4, D ≈ 5.33, E ≈ 6.67. √8 ≈ 2.83, which is between B (2.67) and C (4).',
    topicTags: ['radicals', 'number-line']
  },
  // Question 31
  {
    id: '25MC5-Q31',
    formId: '25MC5',
    questionNumber: 31,
    category: 'S',
    isScored: true,
    difficulty: 3,
    question: 'Deon often flies his kite. He can only fly his kite on days with wind. He does not fly his kite on every day with wind. For any given day, let Event A be that there is wind and let Event B be that Deon flies his kite. Which of the following values can P(A and B) be?',
    choices: ['0', '0.5', '1', '1.5'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'P(A and B) must be between 0 and 1. Since B requires A (flying requires wind), but A does not guarantee B, P(A and B) can be any value from 0 to P(A). 0.5 is a valid probability value.',
    topicTags: ['probability-basic', 'conditional-probability']
  },
  // Question 32
  {
    id: '25MC5-Q32',
    formId: '25MC5',
    questionNumber: 32,
    category: 'A',
    isScored: true,
    difficulty: 3,
    question: 'Whenever (−3x³ + 12x) / (x³ − x² − 6x) is defined, it is equivalent to:',
    choices: ['−2', '1/(x + 3)', '(6 − 3x)/(x + 3)', '(6 − 3x)/(x − 3)'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Numerator: −3x³ + 12x = −3x(x² − 4) = −3x(x−2)(x+2). Denominator: x³ − x² − 6x = x(x² − x − 6) = x(x−3)(x+2). Simplified: −3x(x−2)(x+2) / [x(x−3)(x+2)] = −3(x−2)/(x−3) = (6−3x)/(x−3).',
    topicTags: ['rational-expressions', 'factoring']
  },
  // Question 33
  {
    id: '25MC5-Q33',
    formId: '25MC5',
    questionNumber: 33,
    category: 'A',
    isScored: true,
    difficulty: 2,
    question: 'The roots of a polynomial equation are 0, 2, and −5. Which of the following is a factored form of the equation?',
    choices: ['(x − 2)(x + 5) = 0', 'x(x − 2)(x + 5) = 0', 'x(x + 2)(x − 5) = 0', '(x − 2)(x + 5) = x'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'Roots 0, 2, −5 means factors are x, (x−2), and (x+5). So equation is x(x − 2)(x + 5) = 0.',
    topicTags: ['polynomial-equations', 'roots']
  },
  // Question 34
  {
    id: '25MC5-Q34',
    formId: '25MC5',
    questionNumber: 34,
    category: 'A',
    isScored: true,
    difficulty: 3,
    question: 'If (3x − y)/(x + y) = 5/8, then x/y = ?',
    choices: ['2/19', '13/19', '5/8', '13/7'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Cross multiply: 8(3x − y) = 5(x + y). 24x − 8y = 5x + 5y. 19x = 13y. x/y = 13/19.',
    topicTags: ['ratios', 'algebraic-manipulation']
  },
  // Question 35
  {
    id: '25MC5-Q35',
    formId: '25MC5',
    questionNumber: 35,
    category: 'IES',
    isScored: true,
    difficulty: 2,
    question: 'Let the slope of 3x + 2y = 5 be m₁, and the slope of 6x + 4y = 7 be m₂. Which of the following is true?',
    choices: ['m₁ = m₂', 'm₁ = 2m₂', '2m₁ = m₂', '7m₁ = 5m₂'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'First line: 2y = −3x + 5, y = −3x/2 + 5/2, m₁ = −3/2. Second line: 4y = −6x + 7, y = −6x/4 + 7/4 = −3x/2 + 7/4, m₂ = −3/2. So m₁ = m₂.',
    topicTags: ['slope', 'linear-equations', 'parallel-lines']
  },
  // Question 36
  {
    id: '25MC5-Q36',
    formId: '25MC5',
    questionNumber: 36,
    category: 'F',
    isScored: true,
    difficulty: 3,
    question: 'The piecewise functions f and g are given.\nf(x) = { −x² for x < 0; 1 − x for x ≥ 0 }\ng(x) = { |x| + 7 for x ≤ −1; x − 3 for x > −1 }\nWhat is the value of f(g(−1))?',
    choices: ['−16', '−7', '−5', '−1'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'g(−1): Since −1 ≤ −1, use |x| + 7 = |−1| + 7 = 1 + 7 = 8. f(8): Since 8 ≥ 0, use 1 − x = 1 − 8 = −7.',
    topicTags: ['piecewise-functions', 'composite-functions']
  },
  // Question 37
  {
    id: '25MC5-Q37',
    formId: '25MC5',
    questionNumber: 37,
    category: 'A',
    isScored: true,
    difficulty: 3,
    question: 'Let f be defined by f(x) = 4x + 7. Let g be defined by g(x) = −2x² + 11x + 1. The graphs of y = f(x) and y = g(x) intersect at one of the following (x,y) points. Which one?',
    choices: ['(−2,−1)', '(1½,13)', '(2,1½)', '(13,−1)'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'Set equal: 4x + 7 = −2x² + 11x + 1. 2x² − 7x + 6 = 0. (2x − 3)(x − 2) = 0. x = 3/2 or x = 2. For x = 3/2: f(1.5) = 6 + 7 = 13. Point: (1½, 13).',
    topicTags: ['systems-of-equations', 'quadratic-equations']
  },
  // Question 38 - FIELD TEST (Not Scored)
  {
    id: '25MC5-Q38',
    formId: '25MC5',
    questionNumber: 38,
    category: 'S',
    isScored: false,
    difficulty: 2,
    question: 'A tourism organization randomly selected 100 tourists finishing their summer visit to Spain. The organization asked them how many cities they had toured in the country. The table shows the results. Based on these data, for the population of tourists that visited Spain during the summer, what is the best estimate of the mean number of cities toured?\nTable: Cities: 1, 2, 3; Tourists: 10, 40, 50',
    choices: ['0.8', '2', '2.4', '3'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Mean = (1×10 + 2×40 + 3×50) / 100 = (10 + 80 + 150) / 100 = 240/100 = 2.4.',
    topicTags: ['mean', 'weighted-average']
  },
  // Question 39
  {
    id: '25MC5-Q39',
    formId: '25MC5',
    questionNumber: 39,
    category: 'N',
    isScored: true,
    difficulty: 2,
    question: 'Given that i is the imaginary unit, which of the following numbers is equal to (7 + 4i)²?',
    choices: ['33', '65', '14 + 8i', '33 + 56i'],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: '(7 + 4i)² = 49 + 56i + 16i² = 49 + 56i + 16(−1) = 49 + 56i − 16 = 33 + 56i.',
    topicTags: ['complex-numbers', 'imaginary-numbers']
  },
  // Question 40
  {
    id: '25MC5-Q40',
    formId: '25MC5',
    questionNumber: 40,
    category: 'N',
    isScored: true,
    difficulty: 3,
    question: 'The product of 2 complex numbers, x and y, is a real number that is irrational. Which of the following statements cannot be true?',
    choices: ['Both x and y are rational.', 'Both x and y are imaginary.', 'The product of x and y is √2.', 'The product of x and y is negative.'],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'If both x and y are rational, their product must be rational. But we\'re told the product is irrational. So "Both x and y are rational" cannot be true.',
    topicTags: ['complex-numbers', 'irrational-numbers']
  },
  // Question 41
  {
    id: '25MC5-Q41',
    formId: '25MC5',
    questionNumber: 41,
    category: 'F',
    isScored: true,
    difficulty: 3,
    question: 'The real solution of the equation 3eˣ = 12 is:',
    choices: ['ln 4', '3 ln 12', '4e', 'ln 12 / 3'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: '3eˣ = 12. eˣ = 4. x = ln 4.',
    topicTags: ['exponential-functions', 'logarithms']
  },
  // Question 42
  {
    id: '25MC5-Q42',
    formId: '25MC5',
    questionNumber: 42,
    category: 'G',
    isScored: true,
    difficulty: 3,
    question: 'The figure shows △ABC, a right isosceles triangle, inscribed in a circle with center O and radius 10 cm. What is the length, in centimeters, of arc AB shown as the thick curved line?',
    choices: ['20π', '15π', '10π', '5π'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Right isosceles triangle: right angle at C. AB is diameter (inscribed angle of 90° subtends diameter). But wait - arc AB is a semicircle minus something. Actually, C is at the right angle, so angle ACB = 90°, which means AB subtends 180° from C, so AB is diameter. Arc AB (minor) = the arc not containing C. Central angle for arc AB = 90° (since inscribed angle at C = 45° × 2 = 90°). Actually, if it\'s the minor arc: Arc length = (θ/360) × 2πr = (90/360) × 2π(10) = (1/4) × 20π = 5π.',
    topicTags: ['circles', 'arc-length', 'inscribed-triangles']
  },
  // Question 43
  {
    id: '25MC5-Q43',
    formId: '25MC5',
    questionNumber: 43,
    category: 'IES',
    isScored: true,
    difficulty: 3,
    question: 'It took Sam x minutes to bike the d miles from home to work. Returning home on the same route, it took Sam y minutes. On the way home his average speed was 2 times his average speed on the way to work. Which of the following equations gives y in terms of x?',
    choices: ['y = x/2', 'y = x − 2', 'y = x + 2', 'y = 2x'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'Speed to work = d/x. Speed home = d/y = 2(d/x). So d/y = 2d/x. 1/y = 2/x. y = x/2.',
    topicTags: ['rate-problems', 'algebraic-modeling']
  },
  // Question 44
  {
    id: '25MC5-Q44',
    formId: '25MC5',
    questionNumber: 44,
    category: 'G',
    isScored: true,
    difficulty: 3,
    question: 'The hyperbolas x²/9 − y²/4 = 1 and y²/36 − x²/25 = 1 are graphed in the standard (x,y) coordinate plane. Which of the following equations is an ellipse that intersects all 4 vertices of the hyperbolas?',
    choices: ['x²/9 + y²/36 = 1', 'x²/25 + y²/4 = 1', 'x²/25 + y²/9 = 1', '(x − 9)² + (y − 36)² = 1'],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'First hyperbola vertices: (±3, 0). Second hyperbola vertices: (0, ±6). Ellipse x²/9 + y²/36 = 1 passes through (±3, 0) and (0, ±6).',
    topicTags: ['conic-sections', 'hyperbolas', 'ellipses']
  },
  // Question 45
  {
    id: '25MC5-Q45',
    formId: '25MC5',
    questionNumber: 45,
    category: 'F',
    isScored: true,
    difficulty: 3,
    question: 'Given that f(x) = ³√(2x − 1), which of the following expressions is the inverse function, f⁻¹(x)?',
    choices: ['1 / ³√(2x − 1)', '³√((x + 1)/2)', '(x³ + 1)/2', '(2x − 1)³'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'To find inverse: y = ³√(2x − 1). y³ = 2x − 1. y³ + 1 = 2x. x = (y³ + 1)/2. So f⁻¹(x) = (x³ + 1)/2.',
    topicTags: ['inverse-functions']
  }
];

// Category counts
export const CATEGORY_COUNTS_25MC5 = {
  N: 5,  // Number & Quantity
  A: 7,  // Algebra
  F: 9,  // Functions
  G: 9,  // Geometry
  S: 5,  // Statistics & Probability
  IES: 8 // Integrating Essential Skills
  // Total scored: 41 (4 field test excluded: Q8, Q18, Q28, Q38)
};

// Helper functions
export function getQuestion(questionNumber) {
  return questions_25MC5.find(q => q.questionNumber === questionNumber);
}

export function getScoredQuestions() {
  return questions_25MC5.filter(q => q.isScored !== false);
}

export function getQuestionsByCategory(category) {
  return questions_25MC5.filter(q => q.category === category && q.isScored !== false);
}

export function calculateScaledScore(rawScore) {
  const entry = SCALE_SCORE_TABLE_25MC5.find(e => e.raw === rawScore);
  if (entry) return entry.scale;
  // Find closest
  const sorted = [...SCALE_SCORE_TABLE_25MC5].sort((a, b) => Math.abs(a.raw - rawScore) - Math.abs(b.raw - rawScore));
  return sorted[0]?.scale || 1;
}

console.log(`[Math 25MC5] Loaded: ${questions_25MC5.length} questions (${getScoredQuestions().length} scored)`);
